export default __webpack_public_path__ + "static/media/treehats.e6ebc93c.gif";